import * as React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/base/Modal";
import { Divider } from "@mui/material";
import document from "../../assets/svgs/documentsNew.svg";
import { Ptag } from "components/core/fonts";
import { formatDateSequence } from "utlis/utils";

export default function PaymentDocumentModal({
  onOpen,
  documents,
  handleOpen,
  transactionDate,
}) {
  console.log({documents})
  const handleClose = () => handleOpen(false);

  return (
    <div>
      <Modal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={onOpen}
        onClose={handleClose}
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={{ width: 400 }}>
          <h2 id="unstyled-modal-title" className="modal-title">
            Documents
          </h2>
          <Divider />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "20px",
            }}
          >
            {documents.map((val, key) =>
              DocumentBox(val, transactionDate, key)
            )}
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
}

const DocumentBox = (val, transactionDate) => {
  return (
    <div
      style={{
        border: "1px solid rgba(228, 228, 228, 1)",
        width: "100%",
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        padding: "10px",
        gap: "10px",
        cursor: "pointer",
      }}
      onClick={() => window.open(val)}
    >
      <div
        style={{
          border: "1px solid rgba(240, 239, 239, 1)",
          width: "30px",
          height: "30px",
          borderRadius: "5px",
          backgroundColor: "rgba(240, 239, 239, 1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={document} height="20px" width="17px" />
      </div>
      <div style={{ display: "flex", flexDirection: "column", width: "90%" }}>
        <Ptag
          fontSize="12px"
          fontWeight="400"
          className="truncate-hover-progressbar"
        >
          {val.split("/").pop()}
        </Ptag>
        {console.log({ transactionDate })}
        {transactionDate && (
          <Ptag fontSize="10px" fontWeight="300">
            {formatDateSequence(transactionDate)}
          </Ptag>
        )}
      </div>
    </div>
  );
};

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={clsx({ "base-Backdrop-open": open }, className)}
      ref={ref}
      {...other}
    />
  );
});

Backdrop.propTypes = {
  className: PropTypes.string.isRequired,
  open: PropTypes.bool,
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: absolute;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
  font-family: Montserrat;
`;

const ModalContent = styled("div")(
  ({ theme }) => css`
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    height: 100%;
    text-align: start;
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border-radius: 8px 0 0 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0 4px 12px
      ${theme.palette.mode === "dark" ? "rgb(0 0 0 / 0.5)" : "rgb(0 0 0 / 0.2)"};
    padding: 24px;
    color: ${theme.palette.mode === "dark" ? grey[50] : grey[900]};

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      margin-bottom: 4px;
    }
  `
);
